import React from 'react';

export const PaginationContext = React.createContext<{
  hasMore: boolean;
  isFetching: boolean;
  loadMore: () => void;
} | null>(null);

export const usePaginationContext = () => {
  const context = React.useContext(PaginationContext);
  if (!context) {
    throw new Error(
      'usePaginationContext must be used within PaginationProvider',
    );
  }
  return context;
};

export const ListLayoutContext = React.createContext<{
  maxHeight?: number;
  rowHeight?: number;
}>({});

export const useListLayoutContext = () => React.useContext(ListLayoutContext);
